import { useTranslation } from 'react-i18next';
import { Dropdown, SimpleSelectList } from 'component-library';
import { CountryEnum, type CountryEnumType, type ListDropdownItem } from '@sr/types';
import { useCountries } from '../hooks/useCountries';
import { DropdownWrapper, TopHeaderToggles } from './CountryPicker.styles';

type CountryDropdownList = ListDropdownItem & {
  value: CountryEnumType;
};

type CountryPickerProps = {
  selectedCountry: CountryEnumType | undefined;
  onChange: (country: CountryEnumType) => void;
  allowedCountries?: CountryEnumType[];
};

export const CountryPicker = ({
  selectedCountry: _selectedCountry,
  onChange,
  allowedCountries,
}: CountryPickerProps) => {
  const { t } = useTranslation();
  const { supportedCountryCodes } = useCountries();

  const selectedCountry = _selectedCountry ?? supportedCountryCodes.at(0) ?? CountryEnum.SE;

  const allCountries: CountryDropdownList[] = [
    {
      type: 'value',
      children: [],
      value: CountryEnum.SE,
      label: t('countryPicker.SE'),
    },
    {
      type: 'value',
      children: [],
      value: CountryEnum.NO,
      label: t('countryPicker.NO'),
    },
    {
      type: 'value',
      children: [],
      value: CountryEnum.DK,
      label: t('countryPicker.DK'),
    },
    {
      type: 'value',
      children: [],
      value: CountryEnum.FI,
      label: t('countryPicker.FI'),
    },
    {
      type: 'value',
      children: [],
      value: CountryEnum.PL,
      label: t('countryPicker.PL'),
    },
  ];

  const availableCountries = allowedCountries ?? supportedCountryCodes;
  const filteredCountries = allCountries.filter((country) =>
    availableCountries.includes(country.value),
  );

  if (filteredCountries.length < 2) return null;

  return (
    <TopHeaderToggles>
      <DropdownWrapper>
        <Dropdown
          items={filteredCountries}
          multiSelect={false}
          selectedValues={[selectedCountry]}
          onChange={(newItems) => {
            const selectedItem = filteredCountries.find(({ value }) => value === newItems[0]);

            if (selectedItem) {
              onChange(selectedItem.value);
            }
          }}
          placeholder=""
          label=""
        >
          <SimpleSelectList />
        </Dropdown>
      </DropdownWrapper>
    </TopHeaderToggles>
  );
};
